import styled from 'styled-components';
import {GridTemplate} from '../../shared-components/mixin/GridTemplate';
import {Card} from '../elements/card/Card';
import {TabsWrapper} from '../elements/tabs/Tab';
import {FooterWrapper} from './Footer';
import {MainWrapper} from './Main';
import {FilterAside} from './advanced-filter/FilterFormSetup';
import {AsideWrapper} from './aside/Aside';
import {NoneEntityDetail, TableSelectedBadge} from './page-features/PageContainerTypes';

export const PageGrid = styled.div`
    // === ------------------------------- ===
    // === -------- MainGrid Only -------- ===
    // === ------------------------------- ===

    // 1
    &:has(${MainWrapper}:nth-child(1)) {
        ${GridTemplate({
            areas: '"main" "main"',
            columns: '1fr',
        })};
    }

    // === -------------------------------------- ===
    // === -------- Main && RightSidebar -------- ===
    // === -------------------------------------- ===
    // 2
    &:has(${MainWrapper}:nth-child(1) + ${AsideWrapper}:nth-child(2)),
    &:has(${MainWrapper}:nth-child(1) + ${FilterAside}:nth-child(2)) {
        ${GridTemplate({
            areas: '"main aside"',
            columns: '1fr auto',
        })};
    }

    ///  // ==== --------------------------------------------------- ==== ///
    ///  // ==== ------------------FilterFeature: ------------------ ==== ///
    ///  // ==== -- Entity Overview && Entity RightSidebar -> Filter ==== ///
    ///  // ==== --------------------------------------------------- ==== ///
    //3
    &:has(${MainWrapper}:nth-child(1) + ${FilterAside}:nth-child(2)) {
        ${FilterAside} {
            grid-area: aside;
            columns: '1fr auto';
        }
    }

    // === ------------------------------------- ===
    // === -------- LeftSidebar && Main -------- ===
    // === ------------------------------------- ===
    &:has(${AsideWrapper}:nth-child(1) + ${MainWrapper}:nth-child(2)) {
        ${GridTemplate({
            areas: '"aside main"',
            columns: 'auto 1fr',
        })};
    }

    // === ----------------------------------------------------- ===
    // === -------- LeftSidebar && Main && RightRidebar -------- ===
    // === ----------------------------------------------------- ===
    &:has(${AsideWrapper}:nth-child(1) + ${MainWrapper}:nth-child(2) + ${AsideWrapper}:nth-child(3)) {
        ${GridTemplate({
            areas: '"asideLeft main aside"',
            columns: 'auto 1fr auto',
        })};
        ${AsideWrapper}:nth-child(1) {
            grid-area: asideLeft !important;
        }
    }

    // === -------------------------------------------------- ===
    // === -------- LeftSidebar && (Main && Footer) -------- ===
    // === -------------------------------------------------- ===
    &:has(${AsideWrapper}:nth-child(1) + ${MainWrapper}:nth-child(2) + ${FooterWrapper}:nth-child(3)) {
        ${GridTemplate({
            areas: '"aside main" "aside footer"',
            columns: 'auto 1fr',
            rows: '1fr auto',
        })};

        ${AsideWrapper} {
            z-index: 300;
        }
        ${MainWrapper} {
            height: 100% !important;
            overflow-y: auto;
        }
    }
    // === -------------------------------------------------- ===
    // === -------- (Main && Footer) && RightSidebar -------- ===
    // === -------------------------------------------------- ===
    &:has(${MainWrapper}:nth-child(1) + ${FooterWrapper}:nth-child(2) + ${AsideWrapper}:nth-child(3)) {
        ${GridTemplate({
            areas: '"main aside" "footer aside"',
            columns: '1fr auto ',
            rows: '1fr auto ',
        })};
        ${MainWrapper} {
            height: 100% !important;
            overflow-y: auto;
        }
    }

    ///  // ==== --------------------------------------- ==== ///
    ///  // ==== ------------FilterFeature: ------------ ==== ///
    ///  // ==== -- Entity Overview On --> DetailPage -- ==== ///
    ///  // ==== --------------------------------------- ==== ///
    &:has(${TabsWrapper}:nth-child(1) + ${NoneEntityDetail}:nth-child(2)) {
        grid-template-rows: auto 1fr;
        grid-template-areas: ' tabs' 'detail';

        ${GridTemplate({
            areas: '"tabs" "detail"',
            rows: 'auto 1fr ',
        })};

        ${TabsWrapper} {
            grid-area: tabs;
            padding: var(--grid-padding) var(--grid-padding) 0;
            ${Card.Wrapper} {
                margin-bottom: 0;
            }
        }
    }

    // ==== ------------------------------------------------------ ==== ///
    // ==== ------------------- FilterFeature: ------------------- ==== ///
    // ==== -- Entity Overview On --> DetailPage & RightSidebar -- ==== ///
    // ==== ------------------------------------------------------ ==== ///
    &:has(${TabsWrapper}:nth-child(1) + ${MainWrapper}:nth-child(2) + ${FilterAside}:nth-child(3)) {
        display: grid;
        ${GridTemplate({
            areas: '"tabs aside" "main aside "',
            rows: 'auto 1fr ',
        })};
        > ${TabsWrapper} {
            grid-area: tabs;
            padding: var(--grid-padding) var(--grid-padding) 0;
            ${Card.Wrapper} {
                margin-bottom: 0;
            }
        }
        ${FilterAside} {
            form {
                height: 0;
            }
        }
        ${MainWrapper} {
            height: 100% !important;
        }
    }

    // ==== -------------------------------------------------- ==== ///
    // ==== ----------------- FilterFeature: ----------------- ==== ///
    // ==== ---- In modal table row selection incl Badges ---- ==== ///
    // ==== -------------------------------------------------- ==== ///

    &:has(${MainWrapper}:nth-child(1) + ${FilterAside}:nth-child(2) + ${TableSelectedBadge}:nth-child(3)) {
        display: grid;

        ${GridTemplate({
            areas: '"main aside" "selectedBadge aside "',
            rows: ' 1fr auto ',
        })};

        ${FilterAside} {
            form {
                height: 0;
            }
        }
        ${MainWrapper} {
            height: 100% !important;
        }
    }
`;
